import bugsnagClient from './bugsnag';

export default err => {
  const error = err instanceof Error ? err : new Error(err);
  bugsnagClient.notify(error);
};
